import React from "react";
import "../styles/Projects.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from "react-bootstrap/Carousel";
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const spotlightProjects = {
      "Single Sign On": {
        title: "Single Sign On",
        desc:
          "Allows students to use their existing Brandeis credentials to log into RepairNet, eliminating the need for separate logins and reducing friction in the user experience.",
          // "Value Prop: Saves time, provides ease of access, and increases adoption rates due to convenience.",
        techStack: "Saves Time, Convienient and Accesible",
        link: "https://github.com/jojo142/RepairNet",

        image: "/assets/1.png"
      },
      Facilities: {
        title: "Facilities Request Submission",
        desc:
          "Students can submit requests directly through the platform, detailing the issue they need fixed (e.g., plumbing, electrical, HVAC).",
        techStack: "Simple, Accurately documented and Submitted",
        link: "https://github.com/jojo142/RepairNet",

        image: "/assets/2.png"
      },
      Request: {
        title: "Request Tracking Dashboard",
        desc:
          "User-friendly dashboard where students can monitor the status of their requests, including whether they’ve been assigned to maintenance staff, in progress, or completed. ",
        techStack: "Transparency, Reduces uncertainty",
        link: "https://github.com/jojo142/RepairNet",

        image: "/assets/3.png"
      },
      Notifications: {
        title: "Notifications and Alerts",
        desc:
          "Automated notifications sent to students when their requests have been updated, including when a maintenance visit has been scheduled.",
        techStack: "Keeps students informed and allows them to plan their day around upcoming maintenance visits, reducing interruptions.",
        link: "https://github.com/jojo142/RepairNet",

        image: "/assets/4.png"
      },
      Feedback: {
        title: "Feedback Mechanism",
        desc:
          "After a request has been resolved, students can provide feedback on the service they received, allowing facilities teams to improve based on student input.",
        techStack: "Continuous improvement of the service, User Feedback, Quality Maintenance",
        link: "https://github.com/jojo142/RepairNet",

        image: "/assets/5.png"
      },
      Admin: {
        title: "Admin Portal for Facilities Team",
        desc:
          "A backend portal for the facilities team to manage requests, assign tasks, and communicate with students.",
        techStack: "Analyticson on repair frequency,maintenance costs and assistance in predictive maintenance planning",
        link: "https://github.com/jojo142/RepairNet",

        image: "/assets/6.png"
      }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/features overview</span>
        </div>
        <Carousel>
          {Object.keys(spotlightProjects).map((key, i) => (
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={spotlightProjects[key]["image"]}
                alt={key}
              />
              <div className="caption-bg">
                <Carousel.Caption>
                  <h3>{spotlightProjects[key]["title"]}</h3>
                  <p>
                    {spotlightProjects[key]["desc"]}
                    <p className="techStack">
                      {spotlightProjects[key]["techStack"]}
                    </p>
                  </p>
                  <ExternalLinks
                    githubLink={spotlightProjects[key]["link"]}
                    openLink={spotlightProjects[key]["open"]}
                  ></ExternalLinks>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  }
}

export default Projects;
